import Line1 from "./lines/Line1";
import Line2 from "./lines/Line2";
import Line3 from "./lines/Line3";
import ChartCard from "./ChartCard";
import { AnalyticEvent, InteractiveTimelineStep } from "./types";
import Line4 from "./lines/Line4";
import Line5 from "./lines/Line5";
import Line6 from "./lines/Line6";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";

export const OESTRA_TIMELINE_STEPS: InteractiveTimelineStep[] = [
    {
        week: "WEEK 2",
        nav: {
            title: "Improvement in vaginal health, mood and sleep",
            description: "Early changes in comfort, sleep quality and emotional balance.",
            mobileDescription: "90% of women reported better overall mood, sleep, vaginal health, skin and lighter periods.",
        },
        card: {
            stat: "90%",
            description: "of women reported better overall mood, sleep, vaginal health, skin and lighter periods.",
            note: "*Individual results vary. Based on internal data.",
            svgOverlay: <Line1 />,
            image: {
                desktop: {
                    url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778094899/new_design/tmp2cmxx9eu_2_2_4_gcr3cz.webp",
                    alt: "Oestra hormone progress timeline by week 2",
                },
                mobile: {
                    url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778100069/new_design/tmp2cmxx9eu_2_2_5_qgquca.webp",
                    alt: "Oestra hormone progress timeline by week 2",
                },
            },
        },
    },
    {
        week: "WEEK 4",
        nav: {
            title: "Consistent energy & cycle stability",
            description: "Fewer crashes, more balanced moods, and steadier cycles.",
            mobileDescription: "98% of women said they had lighter and less painful periods, and resolved vaginal dryness.",
        },
        card: {
            stat: "98%",
            description: "of women said they had lighter and less painful periods, and resolved vaginal dryness.",
            svgOverlay: <Line2 />,
            image: {
                desktop: {
                    url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778094899/new_design/tmp2cmxx9eu_2_2_4_1_zpdhjc.webp",
                    alt: "Oestra hormone progress timeline by week 4",
                },
                mobile: {
                    url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778100070/new_design/tmp2cmxx9eu_2_2_5_1_1_uhysob.webp",
                    alt: "Oestra hormone progress timeline by week 4",
                },
            },
        },
    },
    {
        week: "WEEK 6",
        nav: {
            title: "Clearer thinking & reduced anxiety",
            description: "Improved focus, mental clarity, and a calmer nervous system.",
            mobileDescription: <>80% shared that Oestra<sup>®</sup> improved their sleep and mental health.</>,
        },
        card: {
            stat: "80%",
            description: <>shared that Oestra<sup>®</sup> improved their sleep and mental health.</>,
            svgOverlay: <Line3 />,
            image: {
                desktop: {
                    url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778094899/new_design/tmp2cmxx9eu_2_2_4_2_afeewg.webp",
                    alt: "Oestra hormone progress timeline by week 6",
                },
                mobile: {
                    url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778100070/new_design/tmp2cmxx9eu_2_2_5_2_1_jdbw4q.webp",
                    alt: "Oestra hormone progress timeline by week 6",
                },
            },
        },
    },
    {
        week: "WEEK 8",
        nav: {
            title: "Feeling more like yourself again",
            description: "More balanced, rested, and connected to yourself again.",
            mobileDescription: "Early changes in comfort, sleep quality and emotional balance.",
        },
        card: {
            customContent: <ChartCard />,
        },
    },
];

export const OESTRA_COMPACT_STEPS: InteractiveTimelineStep[] = [
    {
        week: "WEEK 2",
        nav: {
            title: <>Improvement in vaginal health, <br />mood and sleep</>,
            description: "Early changes in comfort, sleep quality and emotional balance.",
            mobileDescription: "90% of women reported better overall mood, sleep, vaginal health, skin and lighter periods.",
        },
        card: {
            stat: "90%",
            description: "of women reported better overall mood, sleep, vaginal health, skin and lighter periods.",
            note: "*Individual results vary. Based on internal data.",
            svgOverlay: <Line4 className="translate-x-[20px]" />,
            image: {
                desktop: {
                    url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778574172/new_design/tmp2cmxx9eu_2_2_5_ffq34d.webp",
                    alt: "Oestra hormone progress timeline by week 2",
                    className: "translate-x-[-60px] translate-y-[10px]",
                },
                mobile: {
                    url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778100069/new_design/tmp2cmxx9eu_2_2_5_qgquca.webp",
                    alt: "Oestra hormone progress timeline by week 2",
                },
            },
        },
    },
    {
        week: "WEEK 4",
        nav: {
            title: "Consistent energy & cycle stability",
            description: "Fewer crashes, more balanced moods, and steadier cycles.",
            mobileDescription: "98% of women said they had lighter and less painful periods, and resolved vaginal dryness.",
        },
        card: {
            stat: "98%",
            description: "of women said they had lighter and less painful periods, and resolved vaginal dryness.",
            svgOverlay: <Line5 className="translate-x-[120px]" />,
            image: {
                desktop: {
                    url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778100070/new_design/tmp2cmxx9eu_2_2_5_1_1_uhysob.webp",
                    alt: "Oestra hormone progress timeline by week 4",
                    className: "translate-x-[-20px]",
                },
                mobile: {
                    url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778100070/new_design/tmp2cmxx9eu_2_2_5_1_1_uhysob.webp",
                    alt: "Oestra hormone progress timeline by week 4",
                },
            },
        },
    },
    {
        week: "WEEK 6",
        nav: {
            title: "Clearer thinking & reduced anxiety",
            description: "Improved focus, mental clarity, and a calmer nervous system.",
            mobileDescription: <>80% shared that Oestra<sup>®</sup> improved their sleep and mental health.</>,
        },
        card: {
            stat: "80%",
            description: <>shared that Oestra<sup>®</sup> improved their sleep and mental health.</>,
            svgOverlay: <Line6 className="translate-x-[80px]" />,
            image: {
                desktop: {
                    url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778094899/new_design/tmp2cmxx9eu_2_2_4_2_afeewg.webp",
                    alt: "Oestra hormone progress timeline by week 6",
                },
                mobile: {
                    url: "https://res.cloudinary.com/dirscuuhp/image/upload/v1778100070/new_design/tmp2cmxx9eu_2_2_5_2_1_jdbw4q.webp",
                    alt: "Oestra hormone progress timeline by week 6",
                },
            },
        },
    },
    {
        week: "WEEK 8",
        nav: {
            title: "Feeling more like yourself again",
            description: "More balanced, rested, and connected to yourself again.",
            mobileDescription: "Early changes in comfort, sleep quality and emotional balance.",
        },
        card: {
            customContent: <ChartCard variant="compact" />,
        },
    },
];

export const DEFAULT_TIMELINE_ANALYTIC_EVENT: AnalyticEvent = {
    event_name: GTM_EVENT_NAMES.LP_INTERACTION,
    widget: "your_journey",
};